import { AppName, DropdownField, FieldTypes } from '@hb/shared'
import { useMemo } from 'react'
import {
  adminAccessLevelOptions,
  practiceAccessLevelOptions,
} from '../../../collections/fields/messaging'
import { useApp } from '../../../contexts/AppContext'
import { useAuth } from '../../../store/auth'

const getOptions = (appName: AppName, noPractice = false) => {
  if (appName === 'providers-app') {
    return practiceAccessLevelOptions
  }
  return noPractice
    ? adminAccessLevelOptions.filter(o => o.id !== 'practice')
    : adminAccessLevelOptions
}

export const useAccessLevelField = (placeholder = 'Access Level', noPractice = false) => {
  const { accessLevel } = useAuth()
  const { appName } = useApp()
  return useMemo<DropdownField | null>(
    () =>
      accessLevel !== 'admin'
        ? null
        : {
            placeholder,
            options: getOptions(appName, noPractice),
            type: FieldTypes.DROPDOWN,
          },
    [accessLevel, placeholder, noPractice, appName],
  )
}
